import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {ProductLineItem} from "../types.ts";

export const EditPageNavigation = ({component}: { component: ProductLineItem }) => {

    const breadcrumbs = [
        {
            title: 'Home',
            href: '/dashboard',
        },
        {
            title: 'Product',
            href: `/products/${component.productId}`,
        },
        {
            title: 'Line Items',
            href: `/products/${component.productId}`,
        },
        {
            title: component.product ? component.product.name : component.id
        }
    ].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
